export default "__VITE_PUBLIC_ASSET__f3368635__"